import React from 'react';
import ContentLoader, { Rect } from 'react-content-loader/native';
import { View } from 'react-native';
import { contentLoaderColors } from '../../utils/constant';
export const ImageLoader = ({
  style
}) => /*#__PURE__*/React.createElement(View, {
  style: style
}, /*#__PURE__*/React.createElement(ContentLoader, {
  speed: 2,
  width: 150,
  height: 170,
  viewBox: "0 0 150 170",
  backgroundColor: contentLoaderColors.BACKGROUND_COLOR,
  foregroundColor: contentLoaderColors.FOREGROUND_COLOR
}, /*#__PURE__*/React.createElement(Rect, {
  x: "0",
  y: "0",
  rx: "25",
  ry: "25",
  width: "140",
  height: "140"
})));
//# sourceMappingURL=ImageLoader.js.map